<div class="household-address-row">
  <div class="household-address">
    <gc-text [variant]="'paragraphHeading'">{{ properties.name }}</gc-text>
  </div>
  @if (shouldShowPdfDownload) {
    <app-popup-pdf-download-trigger
      [isLoading]="pdfController.isPdfDownloadInProgress"
      [tooltip]="downloadTooltipLabel"
      (trigger)="onDownloadPreviewPdf($event)"
      (triggerKeydown)="onDownloadPreviewPdfKeyDown($event)"
    />
  }
</div>
<hr />
@if (isExpandedDuctInformation || !isMobileScreen) {
  <app-duct-popup-content
    [multiDuctInformation]="multiDuctProperties"
    [ductInformation]="subductProperties"
  />
}
@if (loadingState.isLoading) {
  <div class="loading-spinner-container">
    <gc-loading-spinner class="loading-spinner" [pixelSize]="24" />
    <gc-text [variant]="'body'">{{
      'pointInfo.informationLoading' | translate
    }}</gc-text>
  </div>
}
<div class="toggle-expandable-button-container">
  @if (isMobileScreen && subductProperties) {
    <gc-button
      class="f"
      [variant]="'utility'"
      [size]="'small'"
      [icon]="isExpandedDuctInformation ? 'chevronUp' : 'chevronDown'"
      [iconPosition]="'right'"
      (clicked)="toggleExpandableContent()"
      >{{
        (isExpandedDuctInformation
          ? 'pointInfo.showLess'
          : 'pointInfo.showMore'
        ) | translate
      }}</gc-button
    >
  }
</div>
<div class="installation-report-btn">
  <gc-button
    [variant]="'primary'"
    [size]="'full'"
    (clicked)="handleOnClickButton()"
    [disabled]="spanRolesEdit | disableByRoles: userRoles!"
  >
    {{
      isHpReport
        ? ('report.open' | translate)
        : ('installationReport.popUpBtnText' | translate)
    }}
  </gc-button>
  <div class="close-button">
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      (clicked)="onClosePopup()"
    >
      {{ 'close' | translate }}
    </gc-button>
  </div>
</div>
